import React, {Component} from 'react';
import {connect} from "react-redux";
import {fetchQuestionAnswerRevisions} from "../../actions/questionAnswersRevisions";
import moment from "moment";
import { mapRevisionItemToValue} from "../../helpers/questions/functions";
import _ from "lodash";
import {APPLICATION_OPPONENT_ENUM, MEDICAL_EXPERT_FEES_ENUM} from "../../helpers/variables";
import { Link, FormGroup, Loader } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS, INPUT_TYPE } from "../../helpers/formGroupVariants";
import {
    APPLICATION, APPLICATION_MEDICAL_EXPERT_FEES, APPLICATION_OPPONENT, BREACH_CAUSATION_CP_ID, 
    DOTS, LEFT, MEDIUM, MOMENT_DATE_TIME_FORMAT, TERTIARY, WORK_SOURCE_ID_MN,
} from "../../helpers/constants";
import CONTENT_STRINGS from "../../helpers/contentStrings";
class FormQuestionAnswerRevisions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            pageSize: 2
        }
    }

    componentDidMount() {
        if(
            this.props.application
            && this.props.application.id
            && this.props.historyItem
            && this.props.historyItem.values
            && this.props.historyItem.values.id
            && this.props.historyItem.editingSetting
            && this.props.historyItem.editingSetting.id
        ) {
            let entityId = 0;
            if(this.props.historyItem.editingSetting.tableName === APPLICATION){
                entityId = 0;
            } else if(this.props.historyItem.editingSetting.questionId) {
                entityId = this.props.historyItem.values.id
            } else if(this.props.historyItem.editingSetting.tableName === APPLICATION_OPPONENT){
                entityId = this.props.historyItem.entityId;
            } else if(this.props.historyItem.editingSetting.tableName === APPLICATION_MEDICAL_EXPERT_FEES){
                entityId = this.props.historyItem.entityId;
            }

            this.props.fetchQuestionAnswerRevisions({
                applicationId: this.props.application.id,
                editingSettingId: this.props.historyItem.editingSetting.id,
                entityId: entityId //todo: handle questions, opponent, fees and fields as well
            })
        }
    }

    viewMore = () => {
        this.setState({page: this.state.page + 1})
    };

    viewLess = () => {
        this.setState({page: this.state.page > 1 ? (this.state.page - 1) : this.state.page })
    };

    getRevisionItems = () => {
        const items = [];
        if(!this.props.applicationAnswerRevisionItem.applicationAnswerRevisionsDtos){
            return items;
        }

        let revItems = this.props.applicationAnswerRevisionItem.applicationAnswerRevisionsDtos;
        if(this.props.historyItem.editingSetting.tableName === APPLICATION_OPPONENT){
            revItems = revItems
                .filter(item => item.applicationAnswerRevisionItemDtos[0].columnName === APPLICATION_OPPONENT_ENUM[this.props.historyItem.values.machineName]);
        }

        revItems.forEach(revision => {
            if(!this.props.historyItem.editingSetting || !this.props.historyItem.values){
                return {}
            }

            let change = "";
            let name = "";
            change = mapRevisionItemToValue(revision.applicationAnswerRevisionItemDtos[0]);
            //todo: handle fields
            if(this.props.historyItem.editingSetting.tableName === APPLICATION){
                if(this.props.historyItem.editingSetting.columnName === WORK_SOURCE_ID_MN){
                    const option = this.props.solicitorGroupWorkSources.find(i => (
                        i.id
                        && change
                        && change.toString() === i.id.toString()
                    ));
                    change = option ? option.name : change;
                }
            }

            // handle questions
            if(this.props.historyItem.editingSetting.questionId){
                if(this.props.historyItem.values.inputType === INPUT_TYPE.DROP_DOWN){
                    const selectedOption = this.props.historyItem.values.options.find( o => {return (
                        o.id
                        && change
                        && o.id.toString() === change.toString()
                    )});
                    change = selectedOption ? selectedOption.name : change;
                }
            }

            // handle opponents
            if(this.props.historyItem.editingSetting.tableName === APPLICATION_OPPONENT){
                if(this.props.historyItem.values.inputType === INPUT_TYPE.DROP_DOWN){
                    const selectedOption = this.props.historyItem.values.options.find( o => {return (
                        o.id
                        && change
                        && o.id.toString() === change.toString()
                    )});
                    change = selectedOption ? selectedOption.name : "";
                }
            }

            // handle fees
            if(this.props.historyItem.editingSetting.tableName === APPLICATION_MEDICAL_EXPERT_FEES){
                if(revision.applicationAnswerRevisionItemDtos[0].columnName === BREACH_CAUSATION_CP_ID){
                    const option = this.props.breachCausationCpOptions.find(i => (
                        i.id
                        && change
                        && i.id.toString() === change.toString()
                    ));
                    change = option ? option.name : change;
                }
                const fee  = MEDICAL_EXPERT_FEES_ENUM[revision.applicationAnswerRevisionItemDtos[0].columnName];
                name = fee ? fee.name : name;
            }


            if( !(this.props.historyItem.editingSetting.tableName === APPLICATION_OPPONENT && !change) ) {
                items.push({
                    date: moment(revision.revisionDate).format(MOMENT_DATE_TIME_FORMAT),
                    change: change,
                    name: name ? name : null
                })
            }

        });
        return _.chain(items)
            .orderBy(i => i.date , "desc")
            .value();
    };

    render() {
        const {historyItem, fetchingRevisionItem} = this.props;
        if(fetchingRevisionItem){
            return ( <Loader variant={DOTS} dotSize={MEDIUM}/> )
        }

        const revisionItems = this.getRevisionItems();
        const reachedBottom = revisionItems.length <= (this.state.pageSize * this.state.page);
        return (
            <div>
                <div className={"form-horizontal"}>
                    <FormGroup 
                        labelSize={'col-sm-4'}
                        inputSize={'manageSolicitorAccount-data col-sm-4'}
                        label={''}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            id: 'revision-change-id',
                            name: 'revision-change',
                            label: CONTENT_STRINGS.CHANGE_FROM
                        }}
                        hasInlineElements={true}
                        inlineGroupElements={<div style={{ marginTop: '7px' }}><strong>{CONTENT_STRINGS.DATE_CHANGED}</strong></div>}
                        formGroupTestId={'application-history-revision-change'}
                    />
                    {
                        this.props.historyItem.editingSetting.tableName === APPLICATION_MEDICAL_EXPERT_FEES 
                        ?
                            <>
                                {
                                    revisionItems.slice(0, (this.state.page * this.state.pageSize) )
                                        .map((item, index) => (
                                            <div className='row' key={index}>
                                                <div className='col-sm-12'>
                                                    <FormGroup 
                                                        labelSize={'col-sm-4'}
                                                        inputSize={'manageSolicitorAccount-data col-sm-4'}
                                                        label={item.name}
                                                        variant={FORM_GROUP_VARIANTS.PLAIN}
                                                        inputProps={{
                                                            id: `revision-${index}-id`,
                                                            name: `revision-${index}`,
                                                            label: item.change
                                                        }}
                                                        hasInlineElements={true}
                                                        inlineGroupElements={<div style={{ marginTop: '7px' }}><strong>{item.date}</strong></div>}
                                                        formGroupTestId={`revision-modal-${historyItem.values.machineName}-history-row-${index}`}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    )
                                }
                            </>
                        :
                            <>
                                {
                                    revisionItems
                                        .slice(0, (this.state.page * this.state.pageSize) )
                                        .map((item, index) => (
                                            <div className='row' key={index}>
                                                <div className='col-sm-12'>
                                                    <FormGroup 
                                                        labelSize={'col-sm-4'}
                                                        inputSize={'manageSolicitorAccount-data col-sm-4'}
                                                        label={historyItem.values.name}
                                                        variant={FORM_GROUP_VARIANTS.PLAIN}
                                                        inputProps={{
                                                            id: `revision-${index}-id`,
                                                            name: `revision-${index}`,
                                                            label: item.change
                                                        }}
                                                        hasInlineElements={true}
                                                        inlineGroupElements={<div style={{ marginTop: '7px' }}><strong>{item.date}</strong></div>}
                                                        formGroupTestId={`revision-modal-${historyItem.values.machineName}-history-row-${index}`}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                }
                            </>
                    }
                    {!reachedBottom
                    ?
                        <div className={"form-group"}>
                            <div className={"col-sm-8 col-sm-offset-4"}>
                                <Link
                                    arrowDirection={LEFT}
                                    label={CONTENT_STRINGS.SEE_MORE}
                                    onClick={this.viewMore}
                                    variant={TERTIARY}
                                    linkTestId={'application-history-revision-view-more'}
                                />
                            </div>
                        </div>
                    : 
                        null
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        applicationAnswerRevisionItem: state.questionAnswersRevisions.questionAnswerRevisions,
        fetchingRevisionItem: state.questionAnswersRevisions.fetchingQuestionAnswerRevisions,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchQuestionAnswerRevisions: (payload) => {
            dispatch(fetchQuestionAnswerRevisions(payload))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(FormQuestionAnswerRevisions);
